import { FC } from "react";
import { useTranslation } from "@/i18n/client";
import { Button, DialogContent, DialogTitle, IconButton } from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';
import styles from "../../style.module.scss";

interface IProps {
  closeDialog: () => void;
}

const VerificationCodeDom: FC<IProps> = (props) => {
  const {closeDialog} = props;
  const { t } = useTranslation();

  return (
    <div className={styles.verificationCodeDom_drawer_box}>
      <DialogTitle
        id={styles.customized_dialog_title}>
        {t("login.common.emialDrawerTitle")}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => closeDialog()}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent id={styles.customized_dialog_content}>
        <div className={styles.verificationCodeDom_drawer_box}>
          <p>{t("login.common.verificationDesTitle")}</p>
          <ul>
            <li>{t("login.common.verificationDesOne")}</li>
            <li>{t("login.common.verificationDesTwo")}</li>
            <li>{t("login.common.verificationDesThree")}</li>
          </ul>
          <p>- {t("login.common.resendEmail")}</p>
          <p>- {t("login.common.wait")}</p>
          <p>- {t("login.common.whitelist")}</p>

          <div className={styles.footer}>
            <Button
              sx={{
                width: "74px",
                height: "32px",
                fontSize: "16px",
                margin: "25px 0",
                color: "#fff", // 自定义文字颜色
                backgroundColor: "#CC0C1C", // 自定义背景颜色
                textTransform: "none",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#990915", // 悬停时的背景颜色
                },
                "&.Mui-disabled": {
                  backgroundColor: "#FF9FA7",
                  color: "#fff",
                },
              }}
              onClick={() => closeDialog && closeDialog()}
            >
              {t("login.common.ok")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </div>
    
  )
}

export default VerificationCodeDom